// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5da90616","333":"15b3d505","453":"7a090996","455":"8e5d0677","695":"a9f6ccd6"}[chunkId] + ".chunk.js";
};